import React from "react";
import { NX_TYPED_PROMPTS } from "./consult-data.jsx";
// Shared primitives reused across the 3 consultation-assistant variations.
const { useState: useState_p, useEffect: useEffect_p, useRef: useRef_p } = React;

// Tiny SVG mark used as the assistant's avatar — mirrors the NI logo glyph.
function NoriMark({ size = 28, accent = "var(--indigo)", bg = "var(--ink)" }) {
  return (
    <div style={{
      width: size, height: size,
      borderRadius: size * 0.28,
      background: bg,
      display: "flex", alignItems: "center", justifyContent: "center",
      color: accent,
      flexShrink: 0,
      boxShadow: "0 1px 0 rgba(255,255,255,.06) inset, 0 2px 6px -2px rgba(14,18,23,.18)",
    }}>
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.4" />
        <path d="M7 9.5C7 8 8 7 9.5 7s2.5 1 2.5 2.5S11 12 9.5 12s-2.5-1-2.5-2.5Z" fill="currentColor" />
        <path d="M12 9.5C12 8 13 7 14.5 7s2.5 1 2.5 2.5S16 12 14.5 12 12 11 12 9.5Z" fill="currentColor" opacity="0.55" />
        <path d="M7.5 16.5c1 .8 2.7 1.5 4.5 1.5s3.5-.7 4.5-1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    </div>
  );
}

// Tiny "typing" indicator
function TypingDots({ tone = "light" }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 0,
      color: tone === "ink" ? "var(--on-ink-subtle)" : "var(--fg-subtle)",
    }}>
      <span className="dot" /><span className="dot" /><span className="dot" />
    </span>
  );
}

// Attio-style typewriter placeholder. Types each phrase a character at a time,
// holds at full length, deletes, advances — paused whenever `active` is false
// (i.e. the field is focused or already has a draft), and reduced-motion aware.
function useNXTypedPlaceholder(active, phrases) {
  const list = (phrases && phrases.length) ? phrases : NX_TYPED_PROMPTS;
  const [text, setText] = useState_p(list[0]);
  useEffect_p(() => {
    if (!active) return;
    let reduce = false;
    try { reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (_) {}
    let i = 0, j = 0, deleting = false, timer;
    if (reduce) {
      // No typing — just cross-fade the full phrase on a calm cadence.
      setText(list[0]);
      timer = setInterval(() => { i = (i + 1) % list.length; setText(list[i]); }, 3200);
      return () => clearInterval(timer);
    }
    const tick = () => {
      const full = list[i];
      if (!deleting) {
        j += 1; setText(full.slice(0, j));
        if (j >= full.length) { deleting = true; timer = setTimeout(tick, 1700); return; }
        timer = setTimeout(tick, 46);
      } else {
        j -= 1; setText(full.slice(0, j));
        if (j <= 0) { deleting = false; i = (i + 1) % list.length; timer = setTimeout(tick, 300); return; }
        timer = setTimeout(tick, 25);
      }
    };
    timer = setTimeout(tick, 700);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);
  return text;
}

export { NoriMark, TypingDots, useNXTypedPlaceholder };
